import actions from './actions'
import mutations from './mutations'

const state = {
  isLoading: false
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
